import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as earnings from '@webapp/sdk/earnings';
import { Action } from 'redux';
import { LIST_EARNINGS } from '../actions';
import {
  ListEarnings,
  ListEarningsSuccess,
  ListEarningsError,
} from '../action-creators';

export const listEarningsEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, ListEarnings>(LIST_EARNINGS),
    mergeMap(async (action) => {
      try {
        const response = await earnings.list(
          action.key,
          action.ownerId,
          action.dsp,
          action.reportDate,
          action.eligibleDate
        );

        return new ListEarningsSuccess(action.key, response);
      } catch (err) {
        return new ListEarningsError((err as Error).message);
      }
    })
  );
